module.exports = __webpack_public_path__ + "static/media/country_ba.b24fe429.webp";